import { Link } from 'react-router-dom';
import { Button, Card } from '@/components/ui';

export function ForbiddenPage() {
  return (
    <Card className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-lg font-semibold">Ingen adgang</h1>
      <p className="mt-2 text-sm text-ink-muted">
        Din rolle giver ikke adgang til denne side. Har du brug for adgang, kontakt en
        administrator.
      </p>
      <Link to="/dashboard" className="mt-5 inline-block">
        <Button variant="secondary">Tilbage til dashboardet</Button>
      </Link>
    </Card>
  );
}

export function NotFoundPage() {
  return (
    <Card className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-lg font-semibold">Siden findes ikke</h1>
      <p className="mt-2 text-sm text-ink-muted">
        Adressen findes ikke i Codepass. Den kan være flyttet, eller linket kan være forældet.
      </p>
      <Link to="/dashboard" className="mt-5 inline-block">
        <Button variant="secondary">Tilbage til dashboardet</Button>
      </Link>
    </Card>
  );
}
